export default {"src":"/customer-services/_next/static/media/support.13e2f926.svg","height":66,"width":66,"blurWidth":0,"blurHeight":0};